import React from 'react';

import { ReactComponent as GroupageIcon } from 'assets/icons/groupage.svg';
import { ReactComponent as MultiRouteIcon } from 'assets/icons/multiroute.svg';
import { ReactComponent as RecurringIcon } from 'assets/icons/recurring.svg';
import { ReactComponent as RouteFound } from 'assets/icons/route-found.svg';
import { ReactComponent as StarIcon } from 'assets/icons/star.svg';

const RouteType = ({
  suggestion,
  isGroupage,
  isRecurring,
  isMultiroute,
  upgrade,
  numberOfStops,
}) => {
  if (suggestion && suggestion?.upgrade_journey) {
    return (
      <span className="upgrade-suggestion">
        <StarIcon style={{ width: 18, height: 18 }} />
      </span>
    );
  }

  if (upgrade) {
    return (
      <span className={'journey-upgrade'}>
        <StarIcon style={{ width: 18, height: 18 }} />
      </span>
    );
  }

  if (suggestion) {
    return <RouteFound />;
  }

  if (isGroupage) {
    return <GroupageIcon />;
  }

  if (isRecurring) {
    return <RecurringIcon />;
  }

  if (isMultiroute) {
    return (
      <div className="mr-container">
        <div className="mr-number-stops"> {numberOfStops} </div>
        <div className="mr-icon">
          <MultiRouteIcon />
        </div>
      </div>
    );
  }

  return null;
};

export default RouteType;
